import { NgFor, NgIf } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { CategorySvgComponent } from '@curbnturf/custom-svgs/src/lib/category-svg/category-svg.component';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { ActivityLocation, HelperFunctions, IPhoto, User } from '@curbnturf/entities';
import { SaveFavoriteComponent } from '@curbnturf/listing-edit/src/lib/save-favorite/save-favorite.component';
import { SpinnerComponent } from '@curbnturf/ui/src/lib/spinner/spinner.component';
import { UserFacade } from '@curbnturf/user/src/lib/+state/user.facade';
import { IonicModule, ModalController } from '@ionic/angular';
import { ActivityFormModalComponent } from '../add-activity-form/activity-form-modal/activity-form-modal.component';
import { AddActivityFormComponent } from '../add-activity-form/add-activity-form.component';
import { LocationMapComponent } from '../location-map/location-map.component';
import { ActivityLocationPhotoComponent } from './activity-location-photo/activity-location-photo.component';

@Component({
  standalone: true,
  selector: 'curbnturf-activity-location-display',
  templateUrl: './activity-location-display.component.html',
  styleUrls: ['./activity-location-display.component.scss'],
  imports: [
    forwardRef(() => ActivityFormModalComponent),
    ActivityLocationPhotoComponent,
    forwardRef(() => AddActivityFormComponent),
    CategorySvgComponent,
    IonicModule,
    forwardRef(() => LocationMapComponent),
    NgFor,
    NgIf,
    forwardRef(() => SaveFavoriteComponent),
    SiteSvgsComponent,
    SpinnerComponent,
  ],
})
export class ActivityLocationDisplayComponent implements OnInit {
  @Input() activity?: ActivityLocation;

  loaded: boolean = false;
  showAll: boolean = false;
  activitySelected: boolean = false;

  currentUser: User;
  showHeader: boolean = false;

  private _activityArray: ActivityLocation[];
  get activityArray(): ActivityLocation[] {
    if (this.activity && (!this._activityArray || this._activityArray[0] !== this.activity)) {
      this._activityArray = [this.activity];
    } else if (!this.activity) {
      this._activityArray = [];
    }

    return this._activityArray;
  }

  getPhotoUrl = HelperFunctions.getPhotoUrlFlatSmall;
  getUserPhotoUrl = HelperFunctions.getPhotoUrlSquareTiny;

  constructor(
    private userFacade: UserFacade,
    private modalController: ModalController,
  ) {}

  ngOnInit() {
    this.userFacade.currentUserOnce$.subscribe((user) => {
      this.currentUser = user;
    });

    this.showHeader = Capacitor.isNativePlatform();
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async openPhotoModal(photo: IPhoto) {
    const modal = await this.modalController.create({
      component: ActivityLocationPhotoComponent,
      componentProps: {
        currentPhoto: photo,
      },
      cssClass: 'photo-modal',
    });
    await modal.present();
  }

  async openEditModal() {
    const modal = await this.modalController.create({
      component: ActivityFormModalComponent,
      componentProps: {
        activity: this.activity,
      },
    });
    await modal.present();
  }
}
